import {
  FlameIcon,
  CarFront,
  FuelIcon,
  Trees,
  InfoIcon,
} from "lucide-react"

export const getIcon = (type: string) => {
  switch (type) {
    case "fa-square":
      return <FlameIcon size={24} className="tw:text-gray-700" />
    case "fa-map-signs":
      return <CarFront size={24} className="tw:text-gray-700" />
    case "fa-road":
      return <FuelIcon size={24} className="tw:text-gray-700" />
    case "fa-tree":
      return <Trees size={24} className="tw:text-gray-700" />
    default:
      return <InfoIcon size={24} />
  }
}
